import * as React from "react";
import * as ReimgixComponent from "reimgix";
import { analytics, DataLayerInitializationData } from "@lonelyplanet/lp-analytics";
var Reimgix = typeof ReimgixComponent === "object" ? ReimgixComponent.default : ReimgixComponent;
var Image = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, alt = _a.alt, className = _a.className;
    var _b;
    var inBrowser = typeof window !== "undefined";
    return (React.createElement(React.Fragment, null,
        React.createElement(DataLayerInitializationData, { data: (_b = {}, _b[analytics.hasPhoto] = true, _b), indexForEntirePayload: 1 }),
        React.createElement(Reimgix, { lqipParams: {
                blur: "200",
                px: 0,
            }, params: {
                fit: "crop",
                h: height,
                w: width,
            }, src: src }, function (_a) {
            var image = _a.src;
            return (React.createElement("img", { className: className, src: image, alt: alt || "" }));
        })));
};
export default Image;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/image/index.tsx
// module id = Mb82
// module chunks = 2